// Terms link out to other terms documents from more than one surface, and the
// colour is the brand primary rather than the in-prose blue above.
export const TERMS_LINK_CLASS =
  'text-red-400 underline underline-offset-4 hover:text-red-500';

// Excludes group-hover: class cards apply it only when the class still has
// spots, the other cards always do. 24px leading tightens a wrapped title; the
// 2px padding keeps a one-line title's 28px box.
export const CARD_TITLE_LINK_CLASS =
  'font-display text-lg leading-6 py-0.5 font-bold text-gray-900 hover:underline hover:text-red-500 underline-offset-4 transition-colors duration-200';

// The count box beside a list card. From md it copies the card's border, title
// line and gap, so its lines sit level with the card's title and price. Each
// card adds its own md width.
export const CARD_SIDE_BOX_CLASS =
  'flex w-[100px] flex-shrink-0 flex-col gap-3 rounded-xl bg-gray-100 px-3 py-5 md:border md:border-transparent md:px-5';

export const CARD_SIDE_BOX_LINES_CLASS = 'flex flex-col gap-1.5 md:gap-2';

export const CARD_SIDE_BOX_TITLE_CLASS =
  'text-sm font-bold text-gray-900 md:text-base md:leading-7';

export const DESCRIPTION_PROSE =
  'prose-sm text-sm text-gray-700 [&_a]:text-red-500 [&_a]:underline [&_h2]:mb-1 [&_h3]:mb-1 [&_li+li]:mt-1 [&_ol:last-child]:mb-0 [&_ol]:mb-3 [&_ol]:list-decimal [&_ol]:pl-5 [&_p:last-child]:mb-0 [&_p]:mb-3 [&_p]:mt-0 [&_strong]:font-semibold [&_ul:last-child]:mb-0 [&_ul]:mb-3 [&_ul]:list-disc [&_ul]:pl-5';

// Complete standalone string, not composed with DESCRIPTION_PROSE: a partial
// conflict such as [&_p]:my-1 vs [&_p]:mb-3 is one tailwind-merge keeps both
// of, leaving the winner to stylesheet emission order.
export const TERMS_PROSE =
  'text-sm text-gray-700 [&_a]:text-red-500 [&_a]:underline [&_h3:first-child]:mt-0 [&_h3]:mb-2 [&_h3]:mt-5 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-gray-900 [&_li]:mb-1 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:mb-3 [&_strong]:font-semibold [&_ul]:mb-3 [&_ul]:list-disc [&_ul]:pl-5';
